import React, { useEffect, useState } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { useGetLookUpDropdownListQuery } from '../../api';
import { useLanguage } from '../../contexts/LanguageContext';

const WarrantyPaymentTypeRadio = ({ value, onChange, className, disabled, excludeOptions = [], warrType }) => {
    const { getCurrentLanguageId, th } = useLanguage();
    const [selectedWarrantyType, setSelectedWarrantyType] = useState(null);

    const { data: warrantyTypeList = [], isLoading } = useGetLookUpDropdownListQuery({
        GroupCode: 'ITEM_LABOR_WARRANTY_TYPE',
        LanguageId: getCurrentLanguageId()
    });

    const warrantyTypeOptions = React.useMemo(() => {
        let options = warrantyTypeList
            .map((warrantyType) => ({
                id: Number(warrantyType.code),
                text: warrantyType.translatedText,
                displayValue: warrantyType.translatedText,
                code: warrantyType.code
            }))
            .filter((option) => !excludeOptions.includes(option.code));

        // warrType'a göre CODE bazlı filtreleme yap
        if (warrType) {
            options = options.filter(option => {
                // warrType: "SW" (Servis Garantili) ise → sadece code: "3" olanları göster
                if (warrType === 'SW') {
                    return option.code === '3';
                }
                
                // warrType: "MO" (Müşteri Öder) ise → sadece code: "1" olanları göster
                if (warrType === 'MO') {
                    return option.code === '1';
                }
                
                return true;
            });
        }

        return options;
    }, [warrantyTypeList, excludeOptions, warrType]);

    const handleSelectionChange = (option) => {
        setSelectedWarrantyType(option);
        onChange(option ? option.id : null);
    };

    useEffect(() => {
        if (warrantyTypeOptions.length > 0 && value) {
            const found = warrantyTypeOptions.find((option) => option.id === value);
            if (found) {
                if (selectedWarrantyType?.id !== found.id) {
                    setSelectedWarrantyType(found);
                }
            }
        } else if (!value) {
            setSelectedWarrantyType(null);
        }
    }, [value, warrantyTypeOptions]);

    if (isLoading) {
        return <div className={className}>Loading...</div>;
    }

    return (
        <div className={className} style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            {warrantyTypeOptions.map((option) => (
                <div key={option.id} className="field-radiobutton">
                    <RadioButton inputId={`warrantyType_${option.id}`} name="warrantyType" value={option} onChange={(e) => handleSelectionChange(e.value)} checked={selectedWarrantyType?.id === option.id} disabled={disabled} />
                    <label htmlFor={`warrantyType_${option.id}`} className="ml-2">
                        {option.text}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default WarrantyPaymentTypeRadio;
